


































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { UsersModule } from '@/store/Settings/UsersModule';
import UserDetailsEdit from '@/components/Settings/Users/UserDetailsEdit.vue';
import UserRolesEdit from '@/components/Settings/Users/UserRolesEdit.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'UserDetails', components: { UserDetailsEdit, UserRolesEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get user() {
        return UsersModule.user;
    }

    get roles() {
        return this.user.roles;
    }

}
